import { CalendarIcon } from 'shared-widget-components/src/components/Icons';

interface EventDateProps {
  dateFrom: Date | null;
  dateTo: Date | null;
}

/**
 * EventDate component
 * this component is responsible for rendering the date of the event
 * @param dateFrom - the start date of the event
 * @param dateTo - the end date of the event
 * @returns EventDate component
 */

export const EventDate = ({ dateFrom, dateTo }: EventDateProps) => {
  // Format the date using Moment.js
  const formatDate = (dateParam: string) => {
    const date = new Date(dateParam);
    // Helper function to add leading zeros
    const zeroPad = (num: number) => num.toString().padStart(2, '0');

    // Extract year, month, and day
    const year = date.getFullYear();
    const month = zeroPad(date.getMonth() + 1); // getMonth() is zero-indexed
    const day = zeroPad(date.getDate());

    // Extract hours and minutes
    const hours = zeroPad(date.getHours());
    const minutes = zeroPad(date.getMinutes());

    // Format the date as YYYY.MM.DD.
    const formattedDate = `${year}.${month}.${day}.`;

    // If the time is 00:00, return only the date
    if (hours === '00' && minutes === '00') {
      return formattedDate;
    }

    // Otherwise, return the date and time
    return `${formattedDate} ${hours}:${minutes}`;
  };

  if (!dateFrom) return <></>; // in case of no dates

  // in case of both dates are present
  return (
    <div className='flex flex-row min-[1200px]:items-center gap-2 min-[350px]:mb-1 min-[1200px]:mb-2 min-[350px]:items-center'>
      <CalendarIcon />
      <div className='flex gap-1 flex-row min-[350px]:items-center min-[350px]:justify-start min-[1200px]:items-center min-[1200px]:justify-start'>
        <h1 className='font-body'>{formatDate('' + dateFrom)} -</h1>
        <h1 className='font-body'>{dateTo ? formatDate('' + dateTo) : ''}</h1>
      </div>
    </div>
  );
};
